import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { CredentialResponse, PromptMomentNotification } from 'google-one-tap';
import { ApiServiceLogin } from '../../apis/ApiServiceLogin';
import { HttpClient } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2/dist/sweetalert2.js'; 
import { Router } from '@angular/router';
import jwt_decode from 'jwt-decode';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  private apiService: ApiServiceLogin;
  
  @ViewChild('loginRef', {static: true }) loginElement!: ElementRef;
  public auth2: any;
  private googleAuthClientId = environment.googleAuthClientId;

  constructor(
    private http: HttpClient,
    private spinner: NgxSpinnerService,
    private router: Router,
    private ngZone: NgZone){

      if (localStorage.getItem('token') ) {
        this.router.navigate(['/pdg/home']);
      }
    }

  ngOnInit(): void {
    this.apiService = new ApiServiceLogin(this.http);
   
     // @ts-ignore
     window.onGoogleLibraryLoad = () => {
      // @ts-ignore
      google.accounts.id.initialize({
        client_id: this.googleAuthClientId,
        callback: this.handleCredentialResponse.bind(this),
        auto_select: false,
        cancel_on_tap_outside: true,
        hosted_domain: 'zentagroup.com'
      });
      // @ts-ignore
      google.accounts.id.renderButton(
      // @ts-ignore
      document.getElementById("buttonDiv"),
        { theme: "outline", size: "large", width: "100%" } 
      );
      // @ts-ignore
      google.accounts.id.prompt((notification: PromptMomentNotification) => {});
    };
    
  }


  handleCredentialResponse(response: CredentialResponse) {
   
    this.spinner.show();

     let token = {
       tokenGmail: response.credential
     }
    
    this.apiService.postService("login-by-gmail",token).subscribe((rs) => {
      if(rs.code == 0){

        this.spinner.hide()
        localStorage.setItem("token", rs.accessToken);
        localStorage.setItem("avatar", rs.avatar);
        localStorage.setItem("userName", rs.userName);
        this.ngZone.run(() => {
          this.router.navigate(['/pdg/home']);
        })
      }else{
        this.spinner.hide()
        Swal.fire({title:rs.message ,text: '',icon: 'error',heightAuto: false});
      }
    });

    // let token = {
    //   tokenGmail: 'adolfo@zentagroup.com'
    // }

    // this.apiService.postService("login-by-email",token).subscribe((rs) => {
    //   if(rs.code == 0){
    //       this.spinner.hide()
    //       localStorage.setItem("token", rs.accessToken);
    //       localStorage.setItem("avatar", rs.avatar);
    //       localStorage.setItem("userName", rs.userName);
    //       this.ngZone.run(() => {
    //       this.router.navigate(['/pdg/home']);
    //     })
    //   }else{
    //     this.spinner.hide()
    //     Swal.fire(rs.message,"", 'error');
    //   }
    // });

  }

}
